import ZRPopper from '../zr-popper';

window.Popper = ZRPopper; // Required by zrCallout.

/* eslint-disable import/first */
import '@static/js/plugins/jquery.zrCallout';
import '@static/css/plugins/zrCallout.less';
